import { LoadingIcon } from '@readcloud/component-library/components/Base/LoadingIcon';
import { FC, ReactNode } from 'react';

interface DictionaryResultComponentProps {
  word: string;
  error?: string;
  loading: boolean;
  definition?: string;
}

const definitionsContainerStyle = {
  WebkitOverflowScrolling: 'touch' as 'touch',
};

export const DictionaryResultComponent: FC<DictionaryResultComponentProps> = ({
  loading,
  error,
  definition,
}) => (
  <div className="rc-flex rc-h-full rc-flex-col rc-w-full">
    {loading ? (
      <LoadingIcon loading={loading} size="sm" />
    ) : error || definition === null ? (
      <Error>{error || 'No results found'}</Error>
    ) : (
      <div
        style={definitionsContainerStyle}
        className="rc-overflow-auto rc-flex-1"
      >
        {definition}
      </div>
    )}
  </div>
);

export interface Props {
  error?: string;
  query: string;
  definition?: string;
  loading: boolean;
}

const Error: FC<{ children?: ReactNode }> = ({ children, ...rest }) => (
  <div
    className="rc-flex rc-flex-col rc-items-center rc-justify-center"
    {...rest}
  >
    <div className="rc-py-2" />
    <h3>{children}</h3>
  </div>
);

export const DictionarySearch: FC<Props> = ({
  definition,
  error,
  query,
  loading,
}) => (
  <div className="rc-flex rc-w-full rc-relative rc-flex-col rc-p-2 rc-overflow-auto">
    <DictionaryResultComponent
      loading={loading}
      word={query}
      definition={definition}
      error={error}
    />
  </div>
);
